module.exports = __webpack_public_path__ + "img/stock4.b803b06b.png";